import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpDemoEvictor = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 360 154",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_1653_97254",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M0 0.144531H360V145.856C360 150.274 356.418 153.856 352 153.856H8C3.58172 153.856 0 150.274 0 145.856V0.144531Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0.144531H360V145.856C360 150.274 356.418 153.856 352 153.856H8C3.58172 153.856 0 150.274 0 145.856V0.144531Z",
			fill: "#E6DFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 0.144531H360H0ZM361 145.856C361 150.826 356.971 154.856 352 154.856H8C3.02944 154.856 -1 150.826 -1 145.856H1C1 149.722 4.13401 152.856 8 152.856H352C355.866 152.856 359 149.722 359 145.856H361ZM8 154.856C3.02944 154.856 -1 150.826 -1 145.856V0.144531H1V145.856C1 149.722 4.13401 152.856 8 152.856V154.856ZM361 0.144531V145.856C361 150.826 356.971 154.856 352 154.856V152.856C355.866 152.856 359 149.722 359 145.856V0.144531H361Z",
			fill: "#C8BAFF",
			mask: "url(#path-1-inside-1_1653_97254)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.246 20.7576V132.935H43.5815V20.7576H152.246Z",
			fill: "#E6DFFF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M152.246 20.7576V132.935H43.5815V20.7576H152.246Z",
			stroke: "#D15454",
			strokeWidth: .95182
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 42.1599,
			height: 42.1599,
			transform: "translate(51.5376 28.7141)",
			fill: "#7F61F0",
			fillOpacity: .4
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 54.3481,
			y: 31.5247,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 74.0229,
			y: 31.5247,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 54.3481,
			y: 51.1995,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 74.0229,
			y: 51.1995,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 42.1599,
			height: 42.1599,
			transform: "translate(102.13 28.7141)",
			fill: "#7F61F0",
			fillOpacity: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 104.94,
			y: 31.5247,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 104.94,
			y: 51.1995,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 124.615,
			y: 51.1995,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 42.1599,
			height: 42.1599,
			transform: "translate(51.5381 82.874)",
			fill: "#7F61F0",
			fillOpacity: .4
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 54.3486,
			y: 85.6846,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 206.499,
			y: 20.6204,
			width: 108.664,
			height: 58.072,
			fill: "#E6DFFF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 206.499,
			y: 20.6204,
			width: 108.664,
			height: 58.072,
			stroke: "#26BB74",
			strokeWidth: .95182
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 42.1599,
			height: 42.1599,
			transform: "translate(214.456 28.5764)",
			fill: "#7F61F0",
			fillOpacity: .4
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 217.266,
			y: 31.387,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 236.941,
			y: 31.387,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 217.266,
			y: 51.0618,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 236.941,
			y: 51.0618,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 42.1599,
			height: 42.1599,
			transform: "translate(265.047 28.5764)",
			fill: "#7F61F0",
			fillOpacity: .4
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 267.858,
			y: 31.387,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 287.533,
			y: 31.387,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 267.858,
			y: 51.0618,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 287.533,
			y: 51.0618,
			width: 16.864,
			height: 16.864,
			fill: "#7F61F0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M194.938 49.9874C195.124 49.8015 195.124 49.5002 194.938 49.3144L191.91 46.2857C191.724 46.0998 191.422 46.0998 191.237 46.2857C191.051 46.4715 191.051 46.7729 191.237 46.9587L193.929 49.6509L191.237 52.343C191.051 52.5289 191.051 52.8302 191.237 53.0161C191.422 53.2019 191.724 53.2019 191.91 53.0161L194.938 49.9874ZM164.144 49.6509V50.1268H194.602V49.6509V49.175H164.144V49.6509Z",
			fill: "#473297"
		})
	]
});
export default SvgOpDemoEvictor;
